<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">
    <div class="card-header pb-0">
      <h6>Lista de tareas</h6>
      <!-- Botones de acción masiva -->
      <div class="row mt-2" v-if="selectedItems.length > 0">
        <div class="col-12">
          <div class="d-flex gap-2 align-items-center flex-wrap">
            <span class="text-sm font-weight-bold">{{ selectedItems.length }} elemento(s) seleccionado(s)</span>
            <button
              v-if="canBulkMarkAsReceived"
              type="button"
              class="btn btn-sm btn-info"
              @click="bulkMarkAsReceived">
              Marcar como Recibido
            </button>
            <button
              v-if="canBulkMarkAsDelivered"
              type="button"
              class="btn btn-sm btn-warning"
              @click="bulkMarkAsDelivered">
              Marcar como Entregado
            </button>
            <button
              v-if="canBulkMarkAsValidated"
              type="button"
              class="btn btn-sm btn-success"
              @click="bulkMarkAsValidated">
              Marcar como Validado
            </button>
            <button
              type="button"
              class="btn btn-sm btn-secondary"
              @click="clearSelection">
              Limpiar selección
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">

        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                OPCIONES
                <input
                  v-if="selectableItemsCount > 0"
                  type="checkbox"
                  @change="toggleSelectAll"
                  :checked="isAllSelected"
                  style="margin-left: 10px;">
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producción</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Cant. recibida</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Cant. entregada</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Cant. defectuosa</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Fecha recibido</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Fecha entregado</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Fecha validado</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >observación</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Total ganancia</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="value in data" :key="value.id">
              <td class="align-middle text-center">
                <div style="display: flex;justify-content: center; align-items: center;gap: 10px;height: 100%;">
                  <input
                    v-if="value.validated_date == null"
                    type="checkbox"
                    :value="value.id"
                    :disabled="!canSelectItem(value)"
                    @change="handleCheckboxChange(value, $event)"
                    :checked="selectedItems.includes(value.id)">
                  <a
                    @click="checkReceived(value)"
                    class="text-secondary font-weight-bold text-xs cursor-pointer"
                    data-toggle="tooltip"
                    data-original-title="Recibir tarea"
                    v-if="value.received_date == null"
                  >
                    <i class="fa fa-arrow-down"></i>
                  </a>
                  <a
                    @click="checkDelivered(value)"
                    class="text-secondary font-weight-bold text-xs cursor-pointer"
                    data-toggle="tooltip"
                    data-original-title="Entregar tarea"
                    v-if="value.received_date != null && value.delivered_date == null"
                  >
                    <i class="fa fa-arrow-up"></i>
                  </a>
                  <a
                    @click="checkValidated(value)"
                    class="text-secondary font-weight-bold text-xs cursor-pointer"
                    data-toggle="tooltip"
                    data-original-title="Validar tarea"
                    v-if="value.delivered_date != null && value.validated_date == null"
                  >
                    <i class="fa fa-check"></i>
                  </a>
                  <span style="color: forestgreen;" v-if="value.validated_date != null">
                    <i class="fa fa-check"></i>
                  </span>
                </div>
              </td>
              <td class="align-middle">
                <div class="text-secondary text-xs font-weight-bold">
                  Modelo: {{  value?.model?.model?.name  }}
                </div>
                <div class="text-secondary text-xs font-weight-bold">
                  Oficio: {{  value?.oficio?.name  }}
                </div>
                <div class="text-secondary text-xs font-weight-bold">
                  Talla: {{  value?.model?.size?.size  }}
                </div>
                <div class="text-secondary text-xs font-weight-bold">
                  Color: {{  value?.model?.size?.color?.name  }}
                </div>
              </td>
              <td class="align-middle text-center">
                {{ value?.received_quantity }}
              </td>
              <td class="align-middle text-center">
                {{ value?.delivered_quantity }}
              </td>
              <td class="align-middle text-center">
                {{ value?.rejected_quantity }}
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ isValidDate(value.received_date) ? new Date(value.received_date).toLocaleDateString('es-ES') : 'Sin asignar' }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ isValidDate(value.delivered_date) ? new Date(value.delivered_date).toLocaleDateString('es-ES') : 'Sin asignar' }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ isValidDate(value.validated_date) ? new Date(value.validated_date).toLocaleDateString('es-ES') : 'Sin asignar' }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                {{ value.observation }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                {{ parseFloat(value.total).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </span>
              </td>
            </tr>
           
          </tbody>
        </table>

        <div class="pagination p-3">
          <!-- Recorremos los links para generar los botones -->
          <a 
            v-for="link in links" 
            :key="link.label" 
            class="page-item cursor-pointer" 
            @click="fetchData(link.url)" 
            :disabled="!link.url || link.active" 
            :class="{ 'active': link.label === currentPage.toString() }"
          >
            {{ link.label }}
          </a>
        </div>

      </div>

    
    </div>
  </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';

export default {
  name: 'OperadorTasks',
  data() {
    return {
      oficios: [],
      users: [],
      selectedItems: [],
    };
  },
  computed: {
    ...mapGetters('productionUsers', ['allData','currentPage', 'lastPage', 'pagination', 'links']),
    currentPage() {
        return this.$store.state.productionUsers.currentPage;
    },
    lastPage() {
        return this.$store.state.productionUsers.lastPage;
    },
    data() {
        return this.allData || [];
    },
    links() {
      return this.$store.getters['productionUsers/links'];
    },
    selectableItemsCount() {
      return this.data.filter(item => item.validated_date == null).length;
    },
    isAllSelected() {
      const selectableItems = this.data.filter(item => item.validated_date == null);
      if (selectableItems.length === 0) return false;
      if (this.selectedItems.length === 0) return false;
      const state = this.selectedItemsState;
      if (!state) return false;
      const itemsOfSameState = selectableItems.filter(item => this.getItemState(item) === state);
      return itemsOfSameState.length > 0 && itemsOfSameState.every(item => this.selectedItems.includes(item.id));
    },
    canBulkMarkAsReceived() {
      return this.selectedItems.length > 0 && this.data.some(item =>
        this.selectedItems.includes(item.id) && item.received_date == null
      );
    },
    canBulkMarkAsDelivered() {
      return this.selectedItems.length > 0 && this.data.some(item =>
        this.selectedItems.includes(item.id) && item.received_date != null && item.delivered_date == null
      );
    },
    canBulkMarkAsValidated() {
      return this.selectedItems.length > 0 && this.data.some(item =>
        this.selectedItems.includes(item.id) && item.delivered_date != null && item.validated_date == null
      );
    },
    selectedItemsState() {
      if (this.selectedItems.length === 0) return null;
      const firstSelected = this.data.find(item => this.selectedItems.includes(item.id));
      return firstSelected ? this.getItemState(firstSelected) : null;
    },
  },
  methods: {
    getItemState(item) {
      if (item.validated_date != null) return 'validated';
      if (item.delivered_date != null && item.validated_date == null) return 'validate';
      if (item.received_date != null && item.delivered_date == null) return 'deliver';
      if (item.received_date == null) return 'receive';
      return null;
    },
    canSelectItem(item) {
      if (this.selectedItems.length === 0) return true;
      if (item.validated_date != null) return false;
      return this.getItemState(item) === this.selectedItemsState;
    },
    handleCheckboxChange(item, event) {
      const isChecked = event.target.checked;
      const itemState = this.getItemState(item);
      if (item.validated_date != null) {
        event.target.checked = false;
        return;
      }
      if (isChecked) {
        if (this.selectedItems.length === 0) {
          this.selectedItems.push(item.id);
        } else {
          const firstSelected = this.data.find(i => this.selectedItems.includes(i.id));
          const firstSelectedState = firstSelected ? this.getItemState(firstSelected) : null;
          if (itemState === firstSelectedState) {
            this.selectedItems.push(item.id);
          } else {
            event.target.checked = false;
            Swal.fire({
              icon: 'warning',
              title: 'Atención',
              text: 'Solo puede seleccionar registros del mismo estado. Deseleccione los actuales para seleccionar otros.',
              timer: 2000,
              showConfirmButton: false,
            });
          }
        }
      } else {
        const index = this.selectedItems.indexOf(item.id);
        if (index > -1) this.selectedItems.splice(index, 1);
      }
    },
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selectedItems = [];
      } else {
        if (this.selectedItems.length === 0) {
          this.selectedItems = this.data
            .filter(item => item.validated_date == null && item.received_date == null)
            .map(item => item.id);
        } else {
          const state = this.selectedItemsState;
          if (state) {
            this.selectedItems = this.data
              .filter(item => this.getItemState(item) === state)
              .map(item => item.id);
          }
        }
      }
    },
    clearSelection() {
      this.selectedItems = [];
    },
    async bulkMarkAsReceived() {
      if (this.selectedItems.length === 0) {
        await Swal.fire({ icon: 'warning', title: 'Atención', text: 'Debe seleccionar al menos un registro.' });
        return;
      }
      const validIds = this.data
        .filter(item => this.selectedItems.includes(item.id) && item.received_date == null)
        .map(item => item.id);
      if (validIds.length === 0) {
        await Swal.fire({ icon: 'warning', title: 'Atención', text: 'Los registros seleccionados ya están marcados como recibidos o no pueden ser marcados.' });
        return;
      }
      try {
        const result = await Swal.fire({
          title: 'Marcar como Recibido',
          text: `¿Está seguro de marcar ${validIds.length} registro(s) como recibido(s)?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, marcar!',
          cancelButtonText: 'Cancelar'
        });
        if (result.isConfirmed) {
          const response = await this.$store.dispatch('productionUsers/bulkMarkAsReceived', validIds);
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire({ icon: 'success', title: '¡Éxito!', text: response.data.message || 'Registros marcados como recibidos correctamente.' });
            this.clearSelection();
            this.fetchData();
          } else {
            throw new Error(response.data?.message || 'Error al marcar los registros');
          }
        }
      } catch (error) {
        console.error('Error al marcar como recibido:', error);
        await Swal.fire({ icon: 'error', title: 'Error', text: error.response?.data?.message || error.message || 'Error al marcar los registros como recibidos' });
      }
    },
    async bulkMarkAsDelivered() {
      if (this.selectedItems.length === 0) {
        await Swal.fire({ icon: 'warning', title: 'Atención', text: 'Debe seleccionar al menos un registro.' });
        return;
      }
      const validIds = this.data
        .filter(item => this.selectedItems.includes(item.id) && item.received_date != null && item.delivered_date == null)
        .map(item => item.id);
      if (validIds.length === 0) {
        await Swal.fire({ icon: 'warning', title: 'Atención', text: 'Los registros seleccionados ya están marcados como entregados o no pueden ser marcados.' });
        return;
      }
      try {
        const result = await Swal.fire({
          title: 'Marcar como Entregado',
          text: `¿Está seguro de marcar ${validIds.length} registro(s) como entregado(s)?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, marcar!',
          cancelButtonText: 'Cancelar'
        });
        if (result.isConfirmed) {
          const response = await this.$store.dispatch('productionUsers/bulkMarkAsDelivered', validIds);
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire({ icon: 'success', title: '¡Éxito!', text: response.data.message || 'Registros marcados como entregados correctamente.' });
            this.clearSelection();
            this.fetchData();
          } else {
            throw new Error(response.data?.message || 'Error al marcar los registros');
          }
        }
      } catch (error) {
        console.error('Error al marcar como entregado:', error);
        await Swal.fire({ icon: 'error', title: 'Error', text: error.response?.data?.message || error.message || 'Error al marcar los registros como entregados' });
      }
    },
    async bulkMarkAsValidated() {
      if (this.selectedItems.length === 0) {
        await Swal.fire({ icon: 'warning', title: 'Atención', text: 'Debe seleccionar al menos un registro.' });
        return;
      }
      const validIds = this.data
        .filter(item => this.selectedItems.includes(item.id) && item.delivered_date != null && item.validated_date == null)
        .map(item => item.id);
      if (validIds.length === 0) {
        await Swal.fire({ icon: 'warning', title: 'Atención', text: 'Los registros seleccionados ya están marcados como validados o no pueden ser marcados.' });
        return;
      }
      try {
        const result = await Swal.fire({
          title: 'Marcar como Validado',
          text: `¿Está seguro de marcar ${validIds.length} registro(s) como validado(s)?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, marcar!',
          cancelButtonText: 'Cancelar'
        });
        if (result.isConfirmed) {
          const response = await this.$store.dispatch('productionUsers/bulkMarkAsValidated', validIds);
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire({ icon: 'success', title: '¡Éxito!', text: response.data.message || 'Registros marcados como validados correctamente.' });
            this.clearSelection();
            this.fetchData();
          } else {
            throw new Error(response.data?.message || 'Error al marcar los registros');
          }
        }
      } catch (error) {
        console.error('Error al marcar como validado:', error);
        await Swal.fire({ icon: 'error', title: 'Error', text: error.response?.data?.message || error.message || 'Error al marcar los registros como validados' });
      }
    },
    async fetchData(pageUrl = null) {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user) {
          return;
        }

        const params = {
          user_id: user.id,
          page: pageUrl ? new window.URL(pageUrl).searchParams.get('page') || 1 : 1,
        };

        await this.$store.dispatch('productionUsers/fetchData', params);
      } catch (error) {
        console.error('Error al cargar tareas:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al cargar las tareas',
        });
      }
    },
    isValidDate(date) {
      // Verifica si el valor es nulo, indefinido o vacío
      if (!date) {
        return false;
      }
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime());
    },
    async checkReceived(value) {

      try {
        const result = await Swal.fire({
          title: 'Recibir Tarea',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const updatedValue = { ...value };
          updatedValue.received_date = new Date().toISOString().slice(0, 10);

          const response = await this.$store.dispatch("productionUsers/save", updatedValue);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Tarea aceptada!',
              'Recuerda realizar la entrega.',
              'success'
            );

            this.fetchData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async checkDelivered(value) {
      const updatedValue = { ...value };

      try {
        let cantt = Number(updatedValue.received_quantity) - Number(updatedValue.delivered_quantity || 0);

        const { value: formValues } = await Swal.fire({
          title: 'Entregar Tarea',
          html: `
          <div style="text-align: left;">
          <div class="mb-3">
                <label for="swal-input-cant" class="form-label" style="font-weight: bold;">Si entregas una cantidad menor a la recibida, tendras que volver a realizar la entrega del restante</label>
              </div>
              <div class="mb-3" hidden>
                <label for="swal-input-cant" class="form-label" style="font-weight: bold;">Cantidad entregada:</label>
                <input id="swal-input-cant" type="number" class="form-control" placeholder="Cantidad entregada" min="1" value="${cantt}">
              </div>
              <div class="mb-3">
                <label for="swal-input-obs" class="form-label" style="font-weight: bold;">Observación:</label>
                <textarea id="swal-input-obs" class="form-control" placeholder="Agregue una observación" rows="3"></textarea>
              </div>
            </div>`,
          focusConfirm: false,
          preConfirm: () => {
            const cant = document.getElementById('swal-input-cant').value;
            const obs = document.getElementById('swal-input-obs').value;

            return { cant: parseInt(cant, 10), obs };
          },
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar!',
          cancelButtonText: 'Cancelar',
        });

        if (formValues) {
          updatedValue.delivered_date = new Date().toISOString().slice(0, 10);
          updatedValue.delivered_quantity = formValues.cant;
          updatedValue.observation = formValues.obs;

          const response = await this.$store.dispatch("productionUsers/save", updatedValue);
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire(
              'Tarea Entregada!',
              'Excelente trabajo.',
              'success'
            );
            this.fetchData();
          } else {
            throw new Error(response.data.message || 'Error al guardar el registro');
          }
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async getOficios() {
      try {
        const response = await this.$store.dispatch('oficios/getOficios');
        this.oficios = response?.data || [];
      } catch (error) {
        console.error('Error al cargar oficios:', error);
        this.oficios = [];
      }
    },
    async getUsers() {
      try {
        this.users = await this.$store.dispatch('users/getAll', 'all');
      } catch (error) {
        console.error('Error al cargar usuarios:', error);
        this.users = [];
      }
    },
    async checkValidated(value) {
      try {
        // Asegurarse de que oficios y usuarios estén cargados
        if (!this.oficios || this.oficios.length === 0) {
          await this.getOficios();
        }
        if (!this.users || this.users.length === 0) {
          await this.getUsers();
        }

        const { value: formValues } = await Swal.fire({
          title: 'Validar Tarea',
          html: `
            <div style="text-align: left;">
              <!-- Defectos -->
              <div class="mb-3">
                <label for="swal-input-defect" class="form-label" style="font-weight: bold;">Cantidad con defectos (Imperfectos):</label>
                <input id="swal-input-defect" type="number" class="form-control" placeholder="Cantidad con defectos" min="0">
              </div>

              <!-- Campos para nueva tarea cuando hay imperfectos (se muestran cuando hay imperfectos) -->
              <div id="swal-nueva-tarea-section" style="display:none;">
                <div class="mb-3">
                  <label for="swal-select-oficio-nueva" class="form-label" style="font-weight: bold;">Oficio para nueva tarea:</label>
                  <select id="swal-select-oficio-nueva" class="form-control">
                    <option value="">Seleccionar oficio</option>
                    ${this.oficios.map(o => `<option value="${o.id}">${o.name}</option>`).join("")}
                  </select>
                </div>
                <div class="mb-3">
                  <label for="swal-user-nueva" class="form-label" style="font-weight: bold;">Seleccionar usuario de tarea:</label>
                  <select id="swal-user-nueva" class="form-control">
                    <option value="">Seleccionar usuario</option>
                    ${this.users.map(u => `<option value="${u.id}">${u.name}</option>`).join("")}
                  </select>
                </div>
                <div class="mb-3">
                  <label for="swal-observacion-nueva" class="form-label" style="font-weight: bold;">Observación:</label>
                  <textarea id="swal-observacion-nueva" class="form-control" rows="3" placeholder="Agregar observación"></textarea>
                </div>
              </div>

            </div>
          `,
          didOpen: () => {
            const defectInput = document.getElementById('swal-input-defect');
            const nuevaTareaSection = document.getElementById('swal-nueva-tarea-section');

            // Función para actualizar la visibilidad basada en imperfectos
            const updateVisibility = () => {
              const cant = Number(defectInput.value) || 0;
              
              if (cant > 0) {
                // Si hay imperfectos, mostrar campos de nueva tarea
                nuevaTareaSection.style.display = 'block';
              } else {
                // Si no hay imperfectos, ocultar campos de nueva tarea
                nuevaTareaSection.style.display = 'none';
              }
            };

            // Actualizar visibilidad cuando cambia la cantidad de imperfectos
            defectInput.addEventListener('input', updateVisibility);
          },
          focusConfirm: false,
          preConfirm: () => {
            const defectInput = document.getElementById('swal-input-defect').value;

            if (defectInput === '' || isNaN(defectInput)) {
              Swal.showValidationMessage('Debe ingresar una cantidad válida de defectos.');
              return false;
            }
            const cant = Number(defectInput);
            if (cant > Number(value.received_quantity)) {
              Swal.showValidationMessage('La cantidad con defectos supera la asignada.');
              return false;
            }

            // Si hay imperfectos, validar y retornar datos de nueva tarea
            if (cant > 0) {
              const oficioNueva = document.getElementById('swal-select-oficio-nueva')?.value || '';
              const userNueva = document.getElementById('swal-user-nueva')?.value || '';
              const obsNueva = document.getElementById('swal-observacion-nueva')?.value || '';

              if (!oficioNueva) {
                Swal.showValidationMessage('Debe seleccionar un oficio para la nueva tarea.');
                return false;
              }
              if (!userNueva) {
                Swal.showValidationMessage('Debe seleccionar un usuario para la nueva tarea.');
                return false;
              }

              // Usar la cantidad de defectos como cantidad para la nueva tarea
              return {
                defectos: cant,
                selected_option: 'new_task',
                nueva_tarea: {
                  oficio_id: parseInt(oficioNueva),
                  user_id: parseInt(userNueva),
                  cantidad: cant, // Usar la cantidad de defectos
                  observacion: obsNueva.trim()
                },
                oficio_id: parseInt(oficioNueva)
              };
            }

            // Si no hay imperfectos, solo retornar defectos
            return {
              defectos: cant,
              selected_option: null
            };
          },
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
        });

        if (formValues) {
          // CREAR NUEVA TAREA ANTES DE VALIDAR LA TAREA ACTUAL
          console.log('formValues:', formValues);
          console.log('formValues.nueva_tarea:', formValues.nueva_tarea);
          console.log('formValues.oficio_id:', formValues.oficio_id);
          
          // Manejar nueva tarea cuando hay imperfectos
          if (formValues.selected_option === 'new_task' && formValues.nueva_tarea) {
            try {
              // Fecha de asignación: fecha actual del día
              const today = new Date().toISOString().slice(0, 10);
              
              const newTask = {
                id: 0,
                production_id: value.production_id,
                production_models_id: value.production_models_id,
                oficio_id: formValues.nueva_tarea.oficio_id,
                user_id: formValues.nueva_tarea.user_id,
                received_quantity: formValues.nueva_tarea.cantidad,
                observation: formValues.nueva_tarea.observacion || `Tarea creada automáticamente desde defectuosos de tarea #${value.id}`,
                status: 0,
                assigned_at: today,
              };
              
              console.log('Creando nueva tarea ANTES de validar:', newTask);
              const newTaskResponse = await this.$store.dispatch("productionUsers/save", newTask);
              console.log('Respuesta creación nueva tarea:', newTaskResponse);
              
              if (newTaskResponse && newTaskResponse.status >= 200 && newTaskResponse.status < 300) {
                console.log('Nueva tarea creada exitosamente');
              } else {
                console.error('Error al crear nueva tarea - respuesta:', newTaskResponse);
                throw new Error('Error al crear la nueva tarea');
              }
            } catch (error) {
              console.error("Error al crear nueva tarea:", error);
              await Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al crear la nueva tarea: ' + (error.message || 'Error desconocido') + '. La tarea no se validará.',
              });
              return; // No continuar con la validación si falla la creación de la nueva tarea
            }
          }

          // AHORA SÍ VALIDAR LA TAREA ACTUAL
          // Crear un nuevo objeto para evitar race conditions
          const updatedValue = {
            ...value,
            validated_date: new Date().toISOString().slice(0, 10),
            rejected_quantity: formValues.defectos,
            finish: 1,
            selected_option: formValues.selected_option, // 🔹 Ya viene en inglés
          };

          if (formValues.corte) {
            Object.assign(updatedValue, {
              corte_user_id: formValues.corte.user_id,
              corte_cantidad: formValues.corte.cantidad,
              laundry_observation: formValues.corte.observacion
            });
          }

          if (formValues.lavanderia) {
            Object.assign(updatedValue, {
              laundry_observation: formValues.lavanderia.observacion
            });
          }

          if (formValues.arreglos) {
            Object.assign(updatedValue, {
              arreglo_user_id: formValues.arreglos.user_id,
              arreglo_cantidad: formValues.arreglos.cantidad,
              laundry_observation: formValues.arreglos.observacion,
            });
          }

          const response = await this.$store.dispatch("productionUsers/save", updatedValue);
          if (response && response.status >= 200 && response.status < 300) {

            // Mensaje de éxito
            let successMessage = 'Excelente trabajo.';
            if (formValues.corte || formValues.arreglos) {
              if (formValues.oficio_id) {
                successMessage = 'Tarea validada y nueva tarea creada.';
              } else {
                successMessage = 'Tarea validada.';
              }
            } else if (formValues.lavanderia) {
              successMessage = 'Tarea validada. Observación de lavandería guardada.';
            } else if (formValues.selected_option === 'new_task') {
              successMessage = 'Tarea validada y nueva tarea creada.';
            }

            await Swal.fire('Tarea Validada!', successMessage, 'success');
            this.fetchData();
          } else {
            throw new Error(response.data.message || 'Error al guardar el registro');
          }
        }
      } catch (error) {
        console.error("Error al validar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al validar el registro',
        });
      }
    },
  },
  mounted() {
    this.fetchData(); // Llama a fetchUsers cuando el componente se monta
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.page-item {
  margin: 0 5px;
}
.active {
  font-weight: bold; /* Estilo para la página activa */
}
</style>